module.exports = __webpack_public_path__ + "img/incoming_&_outgoing.b0ca294f.svg";